import { Children, cloneElement, createContext, isValidElement, useContext } from 'react'

import TriangleDown from '../Icons/TriangleDown'
import TriangleUp from '../Icons/TriangleUp'
import styles from './Table.module.scss'

const TableContext = createContext()

const Table = ({
  children,
  widths = [],
  handleTitleCellClick,
  sortIndex,
  sortDirection
}) => {
  return (
    <TableContext.Provider
      value={{
        widths,
        sortIndex,
        sortDirection,
        handleTitleCellClick
      }}
    >
      <div className={styles.tableHolder}>{children}</div>
    </TableContext.Provider>
  )
}

const TableRow = ({ children, className, isTitleRow, style }) => {
  const { widths, handleTitleCellClick, sortIndex, sortDirection } =
    useContext(TableContext)

  const childrenWithProps = Children.map(children, (child, i) => {
    if (isValidElement(child)) {
      let props = {
        cellWidth: widths[i]
      }

      if (isTitleRow && handleTitleCellClick) {
        props.handleClick = () => handleTitleCellClick(i)
      }

      if (isTitleRow && sortIndex === i) {
        props.sortType = sortDirection
      }

      return cloneElement(child, props)
    }

    return child
  })

  return (
    <div className={className} style={style}>
      {childrenWithProps}
    </div>
  )
}

export const Row = ({ children, className }) => (
  <TableRow className={[styles.row, className].join(' ')}>{children}</TableRow>
)

const SortIcon = ({ type }) => {
  return type === 'down' ? <TriangleDown /> : <TriangleUp />
}

export const TitleRow = ({ children, style, className }) => (
  <TableRow isTitleRow className={[styles.titleRow, className].join(' ')} style={style}>
    {children}
  </TableRow>
)

export const TitleCell = ({
  handleClick,
  cellWidth,
  children,
  textAlign = 'flex-start',
  sortType
}) => (
  <div
    onClick={handleClick}
    className={styles.titleColumn}
    style={{
      flexBasis: cellWidth,
      cursor: handleClick ? 'pointer' : 'default',
      fontSize: 10,
      height: 13,
      display: 'flex',
      alignItems: 'self-start',
      justifyContent: textAlign,
      flexWrap: 'wrap',
      lineHeight: '13px'
    }}
  >
    {sortType && <SortIcon type={sortType} />}
    {children}
  </div>
)

export const Cell = ({ cellWidth, children, className, overflow, ...rest }) => {
  //const cellClassName = isHovering && !noHoverStyle ? styles.cellHovering : styles.cell
  const cellClassName = styles.cell

  return (
    <div
      className={[cellClassName, className].join(' ')}
      style={{ flexBasis: cellWidth, overflow: overflow || 'visible', insetInlineEnd: 8 }}
      {...rest}
    >
      {children}
    </div>
  )
}

export const Spacer = ({ cellWidth }) => <div style={{ flexBasis: cellWidth }}></div>

Table.Row = Row

Table.TitleRow = TitleRow

Table.Cell = Cell

Table.TitleCell = TitleCell

export default Table
